import React, { useState, useEffect } from 'react';
// import Dropzone from 'react-dropzone';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import { SortableContainer } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import { get, post } from './axios_call';
import { mapSize, baseurl } from '../general';
import ModelGalleryEdit from '../elements/model/ModelGalleryEdit';
import ModelGalleryEditCrop from '../elements/model/ModelGalleryEditCrop';
import '../elements/model/Model.css';

const SortableList = SortableContainer(({ items }) => (
  <div>
    {items.map((image, index) => (
      <ModelGalleryEdit image={image} index={index} key={image.id} />
    ))}
  </div>
));

const MyUploader = ({ slug, type }) => {
  // specify upload params and url for your files
  // const getUploadParams = ({ meta }) =>
  const getUploadParams = ({ meta }) => {
    return {
      url: `${baseurl}gallery/${type}/${slug}/`,
      headers: { Authorization: `JWT ${localStorage.getItem('token')}` },
  }};

  const handleChangeStatus = ({ meta, file }, status) => { console.log(status, meta, file); };

  const handleSubmit = (files, allFiles) => {
    allFiles.forEach((f) => {
      getUploadParams(f.meta);
      f.remove();
    });
  };
  return (
    <Dropzone
      onChangeStatus={handleChangeStatus}
      onSubmit={handleSubmit}
      getUploadParams={getUploadParams}
      accept="image/*"
    />
  );
};

class SortableComponent extends React.Component {
  state = {
    items: this.props.items,
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ items }) => ({
      items: arrayMove(items, oldIndex, newIndex),
    }));
  };

  saveOrdering = () => {
    const { items } = this.state;
    const { type, slug } = this.props;
    const ids = items.map((img) => img.id);
    post(`gallery/${type}/${slug}`, { ids }).then(() => window.location.reload());
  }

  render() {
    const { items } = this.state;
    return (
      <>
        <button type="button" onClick={this.saveOrdering} className="save_ordering_button">
          Save ordering
        </button>
        <SortableList items={items} axis="xy" onSortEnd={this.onSortEnd} />
      </>
    );
  }
}

const Up = ({ items, slug, type, viewSize }) => {
  const [sort, setSort] = useState(false);
  return (
    <>
      {items.some((item) => Object.keys(item.thumb).length === 0) && (
        <p className="edit_error"> ONE OR MORE IMAGES ARE NOT CROPPED</p>
      )}
      <MyUploader slug={slug} type={type} />
      <button type="button" onClick={() => setSort(!sort)} className="save_ordering_button">
        {`click to start ${sort ? 'crop' : 'sort'} mode`}
      </button>
      <div className={mapSize(viewSize)}>
        { sort
          ? (
            <SortableComponent
              items={items}
              slug={slug}
              type={type}
              viewSize={viewSize}
            />
          ) : items.map((item) => (
            <ModelGalleryEditCrop slug={slug} image={item} viewSize={viewSize} />
          ))}
      </div>
    </>
  );
};

export default (name, gallery, viewSize) => {
  const [images, setImages] = useState([]);
  const [sizes, setSizes] = useState('');
  const [names, setNames] = useState('');
  const [galleries, setGalleries] = useState([]);
  useEffect(() => {
    let sourceOuter;
    get(`representative/${gallery}/${name}`, true).then(([res, source]) => {
      sourceOuter = source;
      setNames(res.data.names);
      setSizes(res.data.sizes);
      setGalleries(res.data.galleries);
      setImages(
        <Up
          viewSize={viewSize}
          items={res.data.gallery.images}
          slug={res.data.names.slug}
          type={res.data.gallery.type}
        />,
      );
    });
    return () => {
      sourceOuter.cancel();
      setSizes('');
      setNames('');
      setImages([]);
    };
  }, [name, gallery, viewSize]);
  return [images, sizes, names, galleries];
};
